import { Projects, ProjectStatus, VersionStatus } from '@usimweb/core/models';

import { Menu } from './menu';
import { SafeUrl } from '@angular/platform-browser';
import { ColorInjector } from '../ColorInjector';

export abstract class Card extends ColorInjector {
  protected isTaskAlive = true;
  protected readonly LOADING_TIME = 3000; // ms
  protected isSim = false;

  // use carditem obj in abstrac class
  // cardItem : any;

  public menuItems = Menu.getMenu(this.environment.APP);

  public previewMargin = '70px';
  public noImageMargin = '55px';
  public descriptionMargin = '0px';
  public cardHeight = '300px';

  public uuid: string = '';
  public projectName: string = '';
  public owner: string = '';
  public materialName: string = '';
  public created_at: string = '';
  public id: string = '';
  public created_by: string = '';
  public preview: SafeUrl = '';
  public progress = 0;
  public credits = 0;
  public peopleAmount = 0;
  public isSupport = false;
  public isFoaming = false;
  public estimatedTime = 'Calculating...';
  public project: Projects = {} as Projects;
  public projectStatus: ProjectStatus = {} as ProjectStatus;
  public versionStatus: VersionStatus = {} as VersionStatus;

  public compareActive = false;
  public isCompareSelected = false;

  public multipleStatusBar = false;

  public heatLossW: number = 0.0;
  public volume: number = 0.0;

  public stonChipConfig: any;

  public modelname: string = '';

  // constructor(@Inject('environment') private environment: Env) {
  //   console.log('env');
  //   console.log(environment);
  // }

  protected checkPermission(projects: Projects): boolean {
    // const currentUser = AuthHandler.basfUserName.toLocaleLowerCase();
    // const role = projects?.user_roles[currentUser];

    // if (role === 'reader') {
    //   return false;
    // }

    return true;
  }

  protected checkIsSim(versions: any) {
    if (versions.length === 0) {
      return false;
    }

    let isSim: boolean = false;
    versions.forEach((version: any) => {
      if (version['status']['overall'] !== 'draft') {
        isSim = true;
      }
    });
    return isSim;
  }
}
